/**
 * Where a token logo can load from, tried in order by TokenLogo. No
 * dependencies, so anything that shows a logo can import it.
 */

// The host itself (from the viewer's browser, which arweave/irys serve when
// they refuse our Worker), a second public IPFS gateway for IPFS logos
// (ipfs.io and friends rate-limit hard), then our image proxy (fixes odd
// content types, cached).
const IPFS_PATH = /^ipfs:\/\/(?:ipfs\/)?(.+)$|^https?:\/\/[^/]+\/ipfs\/(.+)$|^https?:\/\/([a-z0-9]{46,})\.ipfs\.[^/]+\/?(.*)$/i;
export function logoSources(image) {
  if (!image) return [];
  if (!/^(https?|ipfs):\/\//i.test(image)) return [image]; // data: and the like
  const out = [];
  if (/^https?:\/\//i.test(image)) out.push(image);
  const m = image.match(IPFS_PATH);
  const path = m && (m[1] || m[2] || (m[3] && `${m[3]}${m[4] ? `/${m[4]}` : ""}`));
  // The proxy's IPFS gateway can take its full 8s timeout to fail, so a
  // second public gateway goes first for IPFS logos.
  if (path) out.push(`https://gateway.pinata.cloud/ipfs/${path}`);
  out.push(`/api/token-meta/image?uri=${encodeURIComponent(image)}`);
  return out;
}
